import { CameraType } from "APP_ROOT/data/media";
export default {
  name: "distracted_detection",
  localization: {
    en: {
      title: "Distraction detected",
      settingsHeader: "Distraction Detection",
    },
    fr: {
      title: "Chauffeur distrait",
      settingsHeader: "Détection de Distraction",
    }
  },
  proto: {
    name: "EVENT_RAVEN_DISTRACTED_DETECTED",
    value: 142
  },
  isBuiltByDefault: true,
  isBuiltEnvironmentOverride: {
    showcase: false,
  },
  visibility:{
    reports: true,
    coaching: true,
    coachingNoFacialRecognition: true,
    warning: true,
  },
  isConsumerFeature: false,
  defaultCameraType: CameraType.CAMERA_CABIN,
  showBetaDecoration: false,
}
